import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import AdditionalInformation from './additional_information'
import { Boolean } from '../ui'

export default class HMU extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                `${ this.props.type }_beauty_fashion`,
                `${ this.props.type }_sfx`,
                `${ this.props.type }_green_screen`,
                `${ this.props.type }_broadcast`,
                `${ this.props.type }_corporate`,
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const prefix = this.props.type

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Specialty
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors[`${ prefix }_beauty_fashion`] }
                            label="Beauty / Fashion"
                            name={ `${ prefix }_beauty_fashion` }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, `${ prefix }_beauty_fashion`) }
                        />
                        <Boolean
                            error={ errors[`${ prefix }_sfx`] }
                            label="SFX"
                            name={ `${ prefix }_sfx` }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, `${ prefix }_sfx`) }
                        />
                        <Boolean
                            error={ errors[`${ prefix }_green_screen`] }
                            label="Green Screen"
                            name={ `${ prefix }_green_screen` }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, `${ prefix }_green_screen`) }
                        />
                        <Boolean
                            error={ errors[`${ prefix }_broadcast`] }
                            label="Broadcast"
                            name={ `${ prefix }_broadcast` }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, `${ prefix }_broadcast`) }
                        />
                        <Boolean
                            error={ errors[`${ prefix }_corporate`] }
                            label="Corporate"
                            name={ `${ prefix }_corporate` }
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, `${ prefix }_corporate`) }
                        />

                        <AdditionalInformation
                            { ...this.props }
                            label={
                                'Additional details about your kit items and experience. Please ' +
                                'list anything else you want us to know about.'
                            }
                            wrapped={ false }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/hmu.js